module.exports = __webpack_public_path__ + "static/media/tw_soc.fdd63eed.svg";